import { Popover } from "@headlessui/react";
import logo from "../assets/img/logo.svg";
import { useState } from "react";
import MailchimpFormContainer from './MailchimpFormContainer';

export default function Navbar() {

    const [showModal, setShowModal] = useState(false);

    function showModalHandler() {
        setShowModal(true);
        console.log(showModal)
    }
    function hideModalHandler() {
        setShowModal(false);
    }

    return (
        <>
            {showModal && <MailchimpFormContainer onClose={hideModalHandler}></MailchimpFormContainer>}
            <Popover className="relative bg-gray-100 w-full border-b-2 border-transparent" as="nav">
                <div className=" flex justify-between items-center max-w-7xl mx-auto px-4 py-6 sm:px-6 md:justify-start md:space-x-10 lg:px-8">
                    <div className="flex justify-start lg:w-0 lg:flex-1">
                        <img className="w-40 h-8"
                            src={logo} alt="logo"></img>
                    </div>
                    <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                        <button
                            onClick={showModalHandler}
                            className="transition ease-in-out  ml-8 whitespace-nowrap inline-flex items-center justify-center bg-tonder-blue px-6 py-2 border rounded-md shadow-sm text-base font-medium text-white hover:scale-110">
                            Get in touch
                        </button>
                    </div>
                </div>
            </Popover>
        </>

    );
}